module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start03-bd49b3a16f41d1dbc06a23f1d8be4545.gif";